import React, { useState } from "react";
import "./MonthlyReports.css";
import axios from "axios";
import MonthlyReportsTable from "./MonthlyReportsTable.jsx";
import MonthlyReportsForm from "./MonthlyReportsForm.jsx";
import MonthlyReportsFormEdit from "./MonthlyReportsFormEdit.jsx";
import { DocUploadHandler, DeleteDocument } from "../DocUpload/UploadFunctions";

export default function MonthlyReports(props) {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [RQData, setRQData] = useState("");
  const [ReportYearMonth, setReportYearMonth] = useState("Janurary 2021");
  const [EditDate, setEditDate] = useState("");
  const [FileLink, setFileLink] = useState("");

  const HandleRQText = (txt) => {
    setRQData(txt);
  };
  const HandleOtherText = (e, d) => {
    if (d === "ym") {
      setReportYearMonth(e.target.value);
    }
    if (d === "Flink") {
      setFileLink(e);
    }
  };
  const handleMonthlyReportsSubmit = (event) => {
    event.preventDefault();

    const d = new Date();
    let day = String(d);
    setEditDate(day);

    setTable(true);

    let body = {
      monthyear: ReportYearMonth,
      FileLinks: FileLink,
      EditDate: day,
      Text: RQData,
    };

    axios
      .post(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/monthlyreports/" +
          props.data["_id"],
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        // console.log(res);
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleAddMonthlyReports = () => {
    // console.log("clicked1");
    setTable(false);
  };
  const handleEditMonthlyReports = (e) => {
    // console.log(e);
    // console.log("clicked6");
    setEditForm(true);
    setEditData(e);
  };
  const handleFormClose = () => {
    // console.log("clicked1");
    setTable(true);
  };
  const handleEditFormClose = () => {
    // console.log("clicked5");
    setEditForm(false);
  };
  // handleFormClose = () => {
  //   // // console.log("clicked1");
  //   setState({ table: true });
  // };
  const handleMonthlyReportsEditUpdate = (info) => {
    let body = {
      monthyear: info.monthyear,
      FileLinks: info.FileLinks,
      EditDate: info.EditDate,
      Text: info.Text,
    };
    // console.log("update", body);
    axios
      .put(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/monthlyreports/" +
          info.editID,
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });

    setEditForm(false);
  };
  return (
    <React.Fragment>
      {/* <h1>iiiiiiiiiinnnnnnnnnnnnnn{
          JSON.stringify(props.data)}</h1> */}

      {table ? (
        editForm ? (
          <MonthlyReportsFormEdit
            onMonthlyReportsEditUpdate={handleMonthlyReportsEditUpdate}
            onFormEditClose={handleEditFormClose}
            editData={editData}
            HandleRQText={HandleRQText}
            RQ={RQData}
            HandleOtherText={HandleOtherText}
            ReportYearMonth={ReportYearMonth}
            FileLink={FileLink}
          />
        ) : (
          <MonthlyReportsTable
            onAddMonthlyReports={handleAddMonthlyReports}
            onEditMonthlyReports={handleEditMonthlyReports}
            data={props.data}
            back={props.back}
          />
        )
      ) : (
        <MonthlyReportsForm
          onFormClose={handleFormClose}
          SubmitReport={handleMonthlyReportsSubmit}
          HandleRQText={HandleRQText}
          HandleOtherText={HandleOtherText}
          RQ={RQData}
          ReportYearMonth={ReportYearMonth}
          FileLink={FileLink}
        />
      )}
    </React.Fragment>
  );
}
